export const BLOCK_CONTACT_TYPE = 'block_user';
export const UNBLOCK_CONTACT_TYPE = 'unblock_user';
export const CHAT_TYPE_SINGLE = 'chat';
export const CHAT_TYPE_GROUP = 'groupchat';
export const CHAT_TYPE_GROUP_DISAPPEAR = 'group';
export const CHAT_TYPE_BROADCAST = 'broadcast';
export const MSG_PROCESSING_STATUS_ID = 3;
export const MSG_SENT_ACKNOWLEDGE_STATUS_ID = 0;
export const MSG_DELIVERED_STATUS_ID = 1;
export const MSG_SEEN_STATUS_ID = 2;
export const MSG_PROCESSING_STATUS = 'processing';
export const MSG_SENT_ACKNOWLEDGE_STATUS = 'acknowledge';
export const MSG_DELIVERED_STATUS = 'delivered';
export const MSG_DELIVERED_STATUS_CARBON = 'carbonDelivered';
export const MSG_SEEN_STATUS = 'seen';
export const MSG_SEEN_STATUS_CARBON = 'carbonSeen';
export const MSG_SENT_SEEN_STATUS_CARBON = 'carbonSentSeen';
export const MSG_SEEN_ACKNOWLEDGE_STATUS = 'acknowledge';
export const MSG_SENT_STATUS_CARBON = 'carbonSentMessage';
export const MSG_SENT_STATUS = 'sentMessage';
export const MSG_RECEIVE_STATUS_CARBON = 'carbonReceiveMessage';
export const MSG_RECEIVE_STATUS = 'receiveMessage';
export const MSG_DELETE_STATUS_CARBON = 'carbonDeleteMessage';
export const MSG_DELETE_STATUS = 'deleteMessage';
export const USER_PRESENCE_STATUS_ONLINE = 'online';
export const USER_PRESENCE_STATUS_OFFLINE = 'unavailable';
export const GROUP_USER_ADDED = 'userAdded';
export const GROUP_USER_REMOVED = 'userRemoved';
export const GROUP_USER_MADE_ADMIN = 'madeAdmin';
export const GROUP_USER_LEFT = 'userLeft';
// Group affiliation of an admin ('n' is a member).
export const GROUP_ADMIN_USER_TYPE = 'o';
export const GROUP_PROFILE_INFO_UPDATED = 'profileUpdated';
export const GROUP_DISAPPEAR_UPDATED = 'disappearUpdated';
export const POLL_MESSAGE_TYPE = 'poll';
export const GROUP_TITLE_UPDATED = 'groupTitleUpdated';
export const GROUP_IMAGE_UPDATED = 'groupImageUpdated';
export const GROUP_IMAGE_ADDED = 'groupImageAdded';
export const GROUP_DESCRIPTION_ADDED = 'groupDescriptionAdded';
export const GROUP_DESCRIPTION_UPDATED = 'groupDescriptionUpdated';
export const GROUP_CHAT_PROFILE_UPDATED_NOTIFY = 'groupProfileUpdated';
export const GROUP_CREATED = 'groupCreated';
export const LOGOUT = 'logout';
export const STORY_POSTED = 'story_posted';
export const STORY_RECEIVED = 'story_received';
export const STORY_VIEWER_INFO = 'story_viewer_info';
export const STORY_LIKE = 'story_like';
export const MULTI_DEVICE_LOGOUT_MSG = 'New device logged in with this username. Logging out here.';
export const CARBON_LOGOUT = 'carbonLogout';
export const DEFAULT_USER_STATUS = 'Hi there, I’m on Daz!';
export const CONNECTION_STATE_CONNECTED = 'CONNECTED';
export const CONNECTION_STATE_DISCONNECTED = 'DISCONNECTED';
export const CONNECTION_STATE_CONN_FAILED = 'CONNECTIONFAILED';
export const CONNECTION_STATE_AUTH_FAILED = 'AUTHENTICATIONFAILED';
export const CONNECTION_STATE_ERROR_OCCURED = 'ERROROCCURED';
export const CONNECTION_STATE_CONNECTING = 'CONNECTING';
export const CONNECTION_STATE_SYNCING = 'SYNCING';
export const CONNECTION_STATE_SYNC_COMPLETE = 'SYNC_COMPLETE';
export const MSG_CLEAR_CHAT = 'clearChat';
export const MSG_CLEAR_CHAT_CARBON = 'carbonClearChat';
export const MSG_DELETE_CHAT = 'deleteChat';
export const MSG_DELETE_CHAT_CARBON = 'carbonDeleteChat';
export const DELETE_CALL_LOG = 'deleteCallLog';
export const DEFAULT_TITLE_NAME = 'Daz';
export const AUDIO_ACC_WINDOWS = 'audio/vnd.dlna.adts';
export const THIS_MESSAGE_WAS_DELETED = 'This message was deleted';
export const YOU_DELETED_THIS_MESSAGE = 'You deleted this message';
export const BRAND_NAME = 'Daz';
export const MAP_URL = 'https://maps.googleapis.com/maps/api/staticmap';
export const GROUP_UPDATE_ACTIONS = [
    GROUP_USER_ADDED,
    GROUP_USER_REMOVED,
    GROUP_USER_MADE_ADMIN,
    GROUP_PROFILE_INFO_UPDATED,
    GROUP_USER_LEFT,
    GROUP_TITLE_UPDATED,
    GROUP_IMAGE_ADDED,
    GROUP_IMAGE_UPDATED,
    GROUP_DESCRIPTION_ADDED,
    GROUP_DESCRIPTION_UPDATED,
];
export const NEW_CHAT_CONTACT_PERMISSION_DENIED =
    'You have denied contact permission on mobile. Allow permission for Daz to access contacts and start a new chat.';
export const NEW_GROUP_CONTACT_PERMISSION_DENIED =
    'You have denied contact permission on mobile. Allow permission for Daz to access contacts and start a new group.';
export const ADD_PARTICIPANT_GROUP_CONTACT_PERMISSION_DENIED =
    'You have denied contact permission on mobile. Allow permission for Daz to access contacts and add a new participant.';
export const NEW_CALL_CONTACT_PERMISSION_DENIED =
    'You have denied contact permission on mobile. Allow permission for Daz to access contacts and start a new call.';
export const ADD_PARTICIPANT_CALL_CONTACT_PERMISSION_DENIED =
    'You have denied contact permission on mobile. Allow permission for Daz to access contacts and add a new participant.';
export const REPORT_FROM_CONTACT_INFO = 'REPORT_FROM_CONTACT_INFO';
export const LOGIN_EXCEEDED_ERROR_MESSAGE = 'You have reached maximum sessions allowed.';
export const COMMON_ERROR_MESSAGE = 'Something went wrong. Please try again.';
export const SESSION_LOGOUT = 'The session has been logged out';
export const SERVER_LOGOUT = 'serverLogout';

export const SELECTED_FILE_IMAGE_VIDEO = 'imagevideo';
export const SELECTED_FILE_IMAGE = 'image';
export const SELECTED_FILE_VIDEO = 'video';
export const SELECTED_FILE_FILE = 'file';
export const SELECTED_FILE_AUDIO = 'audio';
export const AUDIO_PLAY_EVENT = 'global-audio-play';
export const READ_RECEIPTS = 'If you turn off read receipts you wont be able to see read receipts from other people. ';
export const PROFILE_HIDE = 'Allow others to see your profile picture ';
export const LAST_SEEN = 'Others can see when you were last online';

export const MUTE_STATUS = {
    NOT_MUTED: 0,
    MUTED: 1,
};

export const MAX_PINNED_CHATS = 3;
export const PIN_STATUS_FIELD = 'pinStatus';
export const FAVOURITE_STATUS_FIELD = 'favouriteStatus';
export const UNREAD_FLAG_FIELD = 'unreadFlag';
export const IS_PINNED_FIELD = 'isPinned';
export const IS_FAVOURITE_FIELD = 'isFavourite';
export const IS_UNREAD_FIELD = 'isUnread';

export const CHAT_FILTER = {
    ALL: 'all',
    UNREAD: 'unread',
    FAVORITES: 'favorites',
    GROUPS: 'groups',
    COMMUNITIES: 'communities',
    CHANNELS: 'channels',
};

// FR59: "All" is always first; the rest keep this order until FR188 lets the user reorder them.
export const CHAT_FILTER_ORDER = [
    CHAT_FILTER.ALL,
    CHAT_FILTER.UNREAD,
    CHAT_FILTER.FAVORITES,
    CHAT_FILTER.GROUPS,
    CHAT_FILTER.COMMUNITIES,
    CHAT_FILTER.CHANNELS,
];

// A count this high stops being informative, so FR59 caps the label instead of widening the chip.
export const CHAT_COUNT_DISPLAY_MAX = 99;

export const DESC_MAPPER = {
    seenReceipt: READ_RECEIPTS,
    hideProfile: PROFILE_HIDE,
    lastSeen: LAST_SEEN,
};
